import React, { ReactElement } from 'react';
import Meta, { IMetaProps } from '../../meta';

// Head content for every page under /library.
//
// This used to live in LibraryMain, three levels down the page body, where
// react-helmet merged it with the page's own <Meta>. Spreading the overrides
// preserves that per-tag fall-through — notably, a collections post overrides
// the title/description/og:url while keeping the library og:image below.
export default function LibraryHead({
  children,
  ...overrides
}: IMetaProps): ReactElement {
  return (
    <Meta
      title="Library: Accessibility resources, guides, communities, and more"
      siteName="Stark Library"
      description="Discover the world’s best accessibility resources, curated for you."
      ogTitle="Stark’s Public Library – Accessibility resources, guides, communities, and more"
      ogUrl="https://getstark.co/library"
      ogImgUrl="https://res.cloudinary.com/stark-lab/image/upload/v1761248627/marketing/meta/library_mjsx94.png"
      {...overrides}>
      <link
        rel="alternate"
        type="application/rss+xml"
        title="Stark Library"
        href="https://getstark.co/library-rss.xml"
      />
      {children}
    </Meta>
  );
}
